export const includesValues = (arrayA, arrayB) =>
  arrayA.some((v) => arrayB.includes(v));
